import L from 'leaflet';

interface PopupOffsetResult {
  offset: [number, number];
  className: string;
}

const calculatePolygonPopupOffset = (
  polygon: L.Polygon | L.Polyline,
  map: L.Map,
): PopupOffsetResult => {
  const bounds = polygon.getBounds();
  const center = bounds.getCenter();
  const centerPoint = map.latLngToContainerPoint(center);
  const mapSize = map.getSize();

  const POPUP_WIDTH = 265;
  // Match actual popup dimensions used elsewhere to avoid mis-detection
  const POPUP_HEIGHT = 110;
  const HORIZONTAL_MARGIN = 10;
  const VERTICAL_MARGIN = 20; // Minimum distance from top/bottom edges
  const FIXED_HORIZONTAL_OFFSET = 55; // Half of popup width for centering

  let offsetX = 0;
  let offsetY = -10; // Default: popup above center
  let className = 'leaflet-hover-popup polygon-popup';

  const halfWidth = POPUP_WIDTH / 2;

  // Calculate polygon bounds on screen
  // const northEast = map.latLngToContainerPoint(bounds.getNorthEast());
  // const southWest = map.latLngToContainerPoint(bounds.getSouthWest());
  // const polygonWidth = Math.abs(northEast.x - southWest.x);

  // Horizontal positioning (use fixed offset to align with popup width)
  const preferredX = centerPoint.x;

  // Check if popup would go beyond left edge
  if (preferredX - halfWidth < HORIZONTAL_MARGIN) {
    // Position popup to the right of the polygon
    offsetX = FIXED_HORIZONTAL_OFFSET;
    className += ' popup-offset-left';
  }
  // Check if popup would go beyond right edge
  else if (preferredX + halfWidth > mapSize.x - HORIZONTAL_MARGIN) {
    // Position popup to the left of the polygon
    offsetX = -FIXED_HORIZONTAL_OFFSET;
    className += ' popup-offset-right';
  }

  // Vertical positioning
  const preferredY = centerPoint.y;

  // If showing above would collide with the top edge, show below
  if (preferredY - POPUP_HEIGHT - 55 < VERTICAL_MARGIN) {
    // Position popup below the center point, matching marker logic
    offsetY = POPUP_HEIGHT + 55;
    className += ' popup-bottom';
  }
  // If showing below would collide with the bottom edge, show above
  else if (preferredY + POPUP_HEIGHT + 55 > mapSize.y - VERTICAL_MARGIN) {
    // Position popup above the center point, matching marker default offset
    offsetY = -55;
    className += ' popup-top';
  }

  return { offset: [offsetX, offsetY], className };
};

export default calculatePolygonPopupOffset;
